/*
 * @Author: your name
 * @Date: 2020-11-11 16:32:12
 * @LastEditTime: 2020-11-12 14:37:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/api/home.js
 */
import request from "@/utils/request";
// 首页主题清单信息
export async function retailHomepage(params) {
  const url = `/api/front/product/retailHomepage/retailHomepage`;
  return request(url, { params });
}
// 首页小店信息
export async function findStoreByCondition(params) {
  const url = "/api/front/store/findStoreByCondition";
  return request(url, {
    method: "POST",
    data: params
  });
}
// 主题清单详情列表
export async function queryRetailStoreThemeDetail(params) {
  const url = `/api/front/product/retailStoreTheme/queryRetailStoreThemeDetail/${params.id}?slug=${params.slug}`;
  return request(url);
}

// 获取公告
export async function loadNotice(id, params) {
  const url = `/api/front/notice/loadNotice/${id}`;
  return request(url, { params });
}

// 获取首页弹窗配置
export async function getHomePageDialog(params) {
  const url = "/api/front/homepage/showHomepage";
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取用户订阅卡片
export async function getUserActivitySubCards(params) {
  const url = "/api/product/activitySubCardUser/getUserActivitySubCards";
  return request(url, { params });
}

// 获取热搜关键词
export async function getSearchKeywordList(params) {
  const url = "/api/front/retailSpu/searchKeywordList1";
  return request(url, { params });
}

// 获取站内信推送数量
export async function findTPushCount(params) {
  const url = "/api/front/daemon/push/findTPushCount";
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取秒杀活动列表
export async function seckillHomeList(goodsIds) {
  const url = "/api/front/product/seckill/home/list";
  return request(url, {
    method: "POST",
    data: goodsIds
  });
}

// 获取首页全部商品数据 (对应小程序 homeGetAllGoods)
export async function homeGetAllGoods(params) {
  const url = "/api/front/retailSpu/findClientRetailSpuByParam";
  return request(url, {
    method: "POST",
    data: params
  });
}

// 获取素材圈数据
export async function homeMaterial(params) {
  const url = "/api/front/product/retailHomepage/retailHomepageDetail";
  return request(url, { params });
}

// 获取某一条素材圈详情
export async function selectArticleById(id, params) {
  const url = `/api/front/ugc/article/selectArticleById/${id}`;
  return request(url, { params });
}

// 素材圈收藏
export async function collectArticle(data) {
  const url = "/api/front/ugc/collect/collectArticle";
  return request(url, {
    method: "POST",
    data
  });
}

// 素材圈行为打点
export async function addUgcArticleRecord(data) {
  const url = "/api/front/ugc/ugcArticleRecord/addUgcArticleRecord";
  return request(url, {
    method: "POST",
    data
  });
}

// 获取商品短链接
export async function spuShortLink(data) {
  const url = "/api/daemon/wxmini/spuShortLink";
  return request(url, {
    method: "POST",
    data
  });
}

